import { Component, Input, EventEmitter, Output, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, AbstractControl, FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'app-item-restriction',
    templateUrl: './item-restriction.component.html',
    styleUrls: ['./item-restriction.component.scss'],
    standalone: true,
    imports: [FormsModule, ReactiveFormsModule]
})
export class ItemRestrictionComponent implements OnInit {
  @Input() fg: FormGroup;
  @Output() closeModal = new EventEmitter();
  newRestriction: AbstractControl;
  // Whether the item already had a saved restriction when the modal opened.
  // Clearing an existing restriction is destructive, so we confirm it first.
  hadRestriction = false;
  // Switches the modal into its "confirm removal" state.
  confirmingRemoval = false;

  constructor(private fb: FormBuilder) {}

  ngOnInit() {
    // Prefill the single field with the existing restriction description.
    // The control is initialized from the BE value when the item form is built,
    // so this shows the saved value (or any unsaved edit made earlier), and
    // falls back to the placeholder when empty.
    this.newRestriction = this.fb.control(this.fg.controls.restrictionDescription.value || '');
    this.hadRestriction = !!this.fg.controls.restrictionDescription.value;
  }

  get isEmpty(): boolean {
    const value = this.newRestriction.value;
    return !value || !value.trim();
  }

  close(): void {
    this.closeModal.emit();
  }

  // Save handler. Removing an existing restriction asks for confirmation first;
  // everything else saves straight through.
  save(): void {
    if (this.isEmpty && this.hadRestriction && !this.confirmingRemoval) {
      this.confirmingRemoval = true;
      return;
    }
    this.patchRestriction();
  }

  // Back out of the confirmation prompt and return to editing.
  cancelRemoval(): void {
    this.confirmingRemoval = false;
  }

  patchRestriction() {
    // Only the description is patched here. When it's cleared, the host component
    // forces the Restrictions dropdown to "No" on close — it has the attribute
    // lookup with the real "No" code, which keeps the update payload consistent.
    this.fg.controls.restrictionDescription.patchValue(this.isEmpty ? '' : this.newRestriction.value);
    this.close();
  }

}
